import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components

import SsapHyperDashboard from './hyperDashboards/SsapHyperDashboard';
import MemberHomeHyperDashboard from './hyperDashboards/MemberHomeHyperDashboard';
import Settings from './blocks/Settings';

// ActionCreators

import { changeLang } from '@actions/common/actionCreators';

// Hooks

import { useGodMode } from '@hooks/useGodMode';

// Utils

import { localStorageHyperDashboardTools } from '@utils/tools/localStorageHyperDashboardTools';

// Constants

import { configs } from '@constants/configs/configs';


const HyperDashboard = props => {

    const {
        actions,
        currentLocation,
        language
    } = props;

    const isHyperDashboardShown = useGodMode();

    const preferred =  localStorageHyperDashboardTools.getValueByPropName('preferredRoute', 'SSAP');

    const handleLanguageChange = ({ target: { dataset: { url } } }) => actions.changeLang(url);

    const getLanguageButtons = () => {
        return ['en', 'es'].map(l => (
            <button
                key={l}
                style={{ backgroundColor: l === language ? 'red' : 'blue' }}
                data-url={configs.endpoints.CHANGE_LANGUAGE.processReplacements({ language: l })}
                onClick={ handleLanguageChange }
            >
                { `Switch to ${l.toUpperCase()}` }
            </button>
        ));
    };

    const getHyperDashboard = () => {

        switch(currentLocation) {
            case configs.routes.SSAP:
                return <SsapHyperDashboard />;
            case configs.routes.INDPORTAL:
                return <MemberHomeHyperDashboard/>;
        }
    };

    return isHyperDashboardShown ?
        <div style={{
            margin: '10px 0 0',
            padding: '10px 20px',
            borderRadius: '1px',
            borderBottom: '2px solid #32a6d2',
            backgroundColor: 'rgba(0, 0, 0, 0.05)'
        }}>
            <ul style={{ listStyle: 'none' }}>
                {
                    Object.entries(configs.routes).map(([routeName, routePath]) => (
                        <li key={ routeName } style={{ display: 'inline-block', marginRight: '15px' }}>
                            <a
                                onClick={() => { window.location = routePath; }}
                                style={{ cursor: 'pointer' }}
                            >
                                {
                                    routeName === preferred
                                        ? <b style={{ color: 'red' }}>{routeName}</b>
                                        : routeName
                                }
                            </a>
                        </li>

                    ))
                }
            </ul>
            <Settings { ...{ currentLocation } }/>
            { getHyperDashboard() }
            { getLanguageButtons() }
        </div> : null;
};

const mapStateToProps = state => ({
    language: state.common.environment.language
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeLang
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HyperDashboard);
